var Transport = require('./base');
var util = require('widgets-util');
var listen = require('widgets-util/dom-event-listener');
var onReady = require('widgets-util/dom-ready');

var channelPath = '/ajax-channel/v1';

var domain = document.domain;

function uid () {
    return domain + '-' + (1*new Date()) + '-' + (Math.random()*1000).toFixed();
}

var IFramePostMessage;
module.exports = IFramePostMessage = function IFramePostMessage(options) {
    options = options || {};
    if (options.baseUrl[0] == "/") options.baseUrl = window.location.protocol + options.baseUrl;
    options.channelUrl = options.baseUrl + (options.channelPath || channelPath);

    Transport.call(this, options);

    var that = this;

    this.frame = document.createElement("iframe");
    this.frame.style.display = 'none';
    this.frame.style.visibility = 'hidden';


    this.messageQueue = {};
    this.preLoadQueue = [];

    this.loaded = false;

    listen(this.frame, 'load', function() {
      that.loaded = true;

      while(that.preLoadQueue.length) {
        var data = that.preLoadQueue.shift();
        that.send(data.options, data.callback);
      }
    });

    // set src after onload callback not before!!!
    this.frame.src = this.options.channelUrl;

    listen(window, 'message', function(e) {
      if (e.origin.indexOf(that.options.baseUrl) !== 0)
          return;

      var data = JSON.parse(e.data);
      var requestData = that.messageQueue[data.inGoRequestId];
      if(requestData) {
          var error = null;
          if('error' in data) {
              error = new Error(data.error);
              error.status = data.status;
          }
          requestData.callback(error, data.data);
          delete that.messageQueue[data.inGoRequestId];
      }
    });

    onReady(window, function() {
      document.body.appendChild(that.frame);
    });
};

IFramePostMessage.supported = function() {
    return 'postMessage' in window;
};

util.inherits(IFramePostMessage, Transport);
IFramePostMessage.prototype.constructor = IFramePostMessage;

IFramePostMessage.prototype.send = function(options, callback) {
    if(this.loaded) {
        var id = uid();
        options.inGoRequestId = id;
        this.messageQueue[id] = { id: id, options: options, callback: callback };
        this.frame.contentWindow.postMessage(JSON.stringify(options), this.options.baseUrl); //IE8 and IE9 need that target will be iframe domain (for mystic security reasons)
    } else {
        this.preLoadQueue.push({ options: options, callback: callback });
    }
};
